// extracted by mini-css-extract-plugin
export default {"header":"reference_header__yLfy4"};